import React, { act, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api_url } from "../config/config";
import axios from "axios"

const AddEmployee = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [roll, setRoll] = useState("Employee");
  const [mobilenumber, setMobilenumber] = useState("");
  const[status, setStatus] = useState("Active");
  const [branchData,setBranchData]=useState([])
  const [branchId, setBranchId]=useState("")
const [designation, setDesignation] = useState("");

  const handleSaveChanges = async (e) => {
    e.preventDefault();

    // Check if mobile number has exactly 10 digits
    if (mobilenumber.length !== 10) {
      alert("Please enter a valid mobile number with 10 digits.");
      return;
    }

    // Check if email is valid
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    if(!password || !branchId){
      alert("password and branch is required");
      return
    }

    // Prepare the data payload
    const payload = {
      name: name,
      email: email,
      password: password,
      mobile_number: mobilenumber,
      isActive: status === "Active" ? true : false,
      designation: designation,
      role: roll,
      branch_id:branchId
    };



    // API Call
    try {
      const response = await fetch(`${api_url}/admin/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const result = await response.json();
        alert("Employee details successfully submitted!");
        console.log("API Response:", result);
        navigate("/ng-admin/employee");
      } else {
        const error = await response.json();
        console.error("API Error:", error);
        alert(error.message || "Failed to create employee.");
      }
    } catch (error) {
      console.error("Network Error:", error);
      alert("An error occurred while submitting the form. Please try again.");
    }
  };

      const fetchBranches = async () => {
      try {
        const response = await axios.get(`${api_url}/branches`);

        const rawBranches = response.data.results || [];

        const uniqueBranches = [
          ...new Map(
            rawBranches.map((branch) => [branch.branch_id, branch])
          ).values(),
        ];

        setBranchData(uniqueBranches);
        console.log("Unique Branches:", uniqueBranches);
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };

    useEffect(() => {
      fetchBranches();
    }, []);

  const handleCancel = () => {
    navigate("/ng-admin/add-employee");
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen ">
      <h2 className="text-2xl font-semibold mb-3">Add Employee</h2>

      <div className="max-w-6xl mx-auto bg-white shadow-lg rounded-lg p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <div className="mb-6">
              <h2 className="text-lg font-semibold mb-4">Basic Information</h2>
              <div className="mb-4">
                <label
                  htmlFor="productName"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  className="w-full border border-gray-300 rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="mb-4">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  className="w-full border border-gray-300 rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="mb-4">
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Password
                </label>
                <input
                  id="password"
                  type="text"
                    placeholder="Enter Password"
                  className="w-full border border-gray-300 rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <div className="mb-4">
              <label
                htmlFor="branch"
                className="block text-sm font-medium text-gray-700 mb-2"
              >
                Branch
              </label>
              <select
                id="branch"
                name="branch"
                className="w-full p-2 border border-gray-300 rounded-md"
                value={branchId}
                onChange={(e) => setBranchId(e.target.value)}
                required
              >
                <option value="">Select Branch</option>
                {branchData.map((branch) => (
                  <option key={branch.branch_id} value={branch.branch_id}>
                    {branch.area}
                  </option>
                ))}
              </select>
            </div>


              <div className="mb-4">
                <label
                  htmlFor="mobile_number"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Mobile Number
                </label>
                <input
                  id="mobile_number"
                  type="text"
                  maxLength="10"
                    placeholder="Enter Mobile Number"
                  className="w-full border border-gray-300 rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500"
                  value={mobilenumber}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only digits and trim to 10 characters
                    if (/^\d{0,10}$/.test(value)) {
                      setMobilenumber(value);
                    }
                  }}
                  required
                />
              </div>
  <div className="mb-4">
                <label
                  htmlFor="designation"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Designation
                </label>
                <input
                  type="text"
                  id="designation"
                  className="w-full border border-gray-300 rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter Designation"
                  value={designation}
                  onChange={(e) => setDesignation(e.target.value)}
                  required
                />
              </div>
<div className="mb-4">
                <label
                  htmlFor="isActive"
                  className="block text-sm font-medium text-gray-700 mb-2"
                > 
                  Status
                </label>    
                <select

  id="isActive"
  name="isActive"
  value={status}
  onChange={(e) => setStatus(e.target.value)}
  className="w-full p-2 border border-gray-300 rounded-md"
>
  <option value="Active">Active</option>
  <option value="Inactive">Inactive</option>
</select>  
              </div>
              <div className="mb-4">
                <label
                  htmlFor="role"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Role
                </label>
                <select
                  id="role"
                  name="role"
                  value={roll}
                  onChange={(e) => setRoll(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md"
                >
                  <option value="vendor">Employee</option>
                  <option value="admin">Admin</option>
                </select>
              </div>

              <button
                className="bg-[#3C1F1F] p-2 px-6 rounded-lg text-white"
                onClick={handleSaveChanges}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEmployee;
